// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "main" + "." + "14410f347dbb23126d3b" + ".css";
};